export type IframeMessage = 'success' | 'fail';

export function isInIframe(): boolean {
  return window.top !== window.self;
}

export function iframePostMessage(message: IframeMessage) {
  window.top?.postMessage(message, '*');
}
